import { useQuery } from '@tanstack/react-query';

import { wolfswapApi } from '@/lib/api';
import { fetchBridgeCatalog } from '@/lib/api/speed';
import { queryKeys } from '@/lib/query';

/**
 * Reads the backend's bridge registry (`GET /speed/bridges`): which bridges
 * each chain uses, in failover order, and the legs each can carry. It is the
 * one object the backend selects bridges from, so the testing switch lists
 * exactly what a pin can run. Public (no auth). The registry is a deployment
 * constant, so one read per page load is enough; a backend without the route
 * simply leaves the switch on its built-in list.
 *
 * `enabled` lets the caller defer the read until the surface that needs it
 * (the custodial panel's gear) is actually open.
 */
export function useBridgeCatalog(enabled = true) {
    return useQuery({
        queryKey: queryKeys.speed.bridges(),
        queryFn: async ({ signal }) => fetchBridgeCatalog(wolfswapApi, signal),
        staleTime: Infinity,
        retry: 1,
        enabled,
    });
}
